


































import TreeSearchHandler from '~/components/car/classifieds/search/facets/handlers/TreeSearchHandler.vue'
import BaseSearchHandler from '~/components/car/classifieds/search/facets/handlers/BaseSearchHandler.vue'
import { mapDeps } from '~/plugins/dependency-container/utils'
import LegacySearchService from '~/services/search/LegacySearchService'
import { Facet } from '~/models/search/types'
import {
  defineComponent,
  defineVue3AsyncComponent
} from '~/utils/nuxt3-migration'
import { defineComponentTranslations } from '~/utils/i18n'
import { CLASSIFIED_SEARCH_NS } from '~/store/modules/shared/classifieds/search/state'
import { mapState } from 'vuex'

export default defineComponent({
  components: {
    TreeSearchHandler,
    PostcodeDistanceSearchHandler: defineVue3AsyncComponent(() =>
      import(
        '~/components/car/classifieds/search/facets/handlers/PostcodeDistanceSearchHandler'
      )
    )
  },
  extends: BaseSearchHandler,
  computed: {
    ...mapState(CLASSIFIED_SEARCH_NS, {
      loadingFacets: state => state.loading.facets
    }),
    locationIsSelected() {
      return this.isSelected || this.postcodeFacet?.isSelected
    },
    postcodeFacet() {
      return this.getFacetByName('postcode')
    },
    ...mapDeps({ legacySearchService: LegacySearchService })
  },
  methods: {
    getBindings(handler: Facet) {
      return this.legacySearchService.getFacetComponentBindings(handler)
    },
    onClearButtonClick() {
      this.emitParams([
        {
          name: 'postcode',
          value: null
        },
        {
          name: 'country_code',
          value: null
        },
        {
          name: 'distance',
          value: null
        },
        {
          name: this.defaultUrlArgName,
          value: []
        },
        {
          name: 'rg',
          value: null
        }
      ])
    }
  },
  i18n: defineComponentTranslations({
    select_region: {
      en: 'Select region',
      el: 'Επίλεξε περιοχή'
    }
  })
})
